import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        _setup.DialogBottomSheet,
        {
          attrs: {
            "is-visible": _setup.isDialogOpened,
            width: _setup.isMobile ? undefined : 375,
            "content-class": "rounded-0",
          },
          on: {
            input: _setup.handleInput,
            "dialog-bottom-sheet:change-visible": _setup.closeDialog,
          },
        },
        [
          _c(
            VCard,
            { staticClass: "pt-6 px-4 pb-4", attrs: { tile: "" } },
            [
              _c(
                VForm,
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _setup.handleSubmit.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "text-h6 mb-4" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_setup.t("Возраст пациента", _setup.options)) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(_setup.FieldAge, {
                    staticClass: "mb-4",
                    attrs: { autofocus: "" },
                    model: {
                      value: _setup.filtersStore.unsavedFilters,
                      callback: function ($$v) {
                        _vm.$set(_setup.filtersStore, "unsavedFilters", $$v)
                      },
                      expression: "filtersStore.unsavedFilters",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(_setup.BtnShowDoctors, {
                attrs: { active: _setup.isDialogOpened },
                on: {
                  "click:close": _setup.closeDialog,
                  "click:submit": _setup.applyFilter,
                },
                model: {
                  value: _setup.isActiveButton,
                  callback: function ($$v) {
                    _setup.isActiveButton = $$v
                  },
                  expression: "isActiveButton",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }